import React from 'react';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core';
import { RecommendedArticlePreview } from './recommended-resources-preview/RecommendedArticlePreview';
import { RecommendedVideoPreview } from './recommended-resources-preview/RecommendedVideoPreview';
import { RecommendedPodcastPreview } from './recommended-resources-preview/RecommendedPodcastPreview';
import { CourseRecommendedPaper } from './course-recommended-paper/CourseRecommendedPaper';

const useStyles = makeStyles(theme => ({
  root: {
    width: props => props.small && '100%',
  },
  buttonWrapper: {
    marginTop: theme.spacing(1),
    '& button': {
      width: '100%',
    },
  },
}));

export const RecommendedResource = ({
  course,
  item,
  coursesSiteCopy,
  saveForLaterButton,
  trackingProps,
  small,
  isDashboard = false,
}) => {
  const classes = useStyles();
  const mapTypeToElement = {
    activity: RecommendedArticlePreview,
    video: RecommendedVideoPreview,
    podcast: RecommendedPodcastPreview,
  };
  const type = _get(item.sys, 'contentType.sys.id');
  const Component = mapTypeToElement[type];
  if (!Component) {
    return null;
  }

  return (
    <CourseRecommendedPaper item={item} className={classes.root}>
      <Component
        course={course}
        item={item}
        coursesSiteCopy={coursesSiteCopy}
        trackingProps={trackingProps}
        isDashboard={isDashboard}
        small={small}
      />
      <div className={classes.buttonWrapper}>{saveForLaterButton}</div>
    </CourseRecommendedPaper>
  );
};
